exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media print{.container{width:auto!important}.invoice-preview>div:first-child,.invoice-preview>div:nth-child(2){display:none}.invoice-preview{margin-top:-25px!important}#invoiceOutline{margin-top:0!important;min-height:22.4cm!important;background-position:50% 13cm!important}table tr{border-bottom:none!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-329b3854","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/pages/bookings/invoice/invoice.vue
// module id = 1113
// module chunks = 0